import { useMutation, useQueryClient } from '@tanstack/react-query';
import insurancesApi from '@/features/dashboard/insurances/api/insurancesApi.ts';
import { insurancesApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { InsuranceFormData } from '@/features/dashboard/insurances/schemas/insuranceSchema.ts';
import { insuranceMapper } from '@/features/dashboard/insurances/types/InsuranceWebDto.mapper.ts';
import { toast } from 'sonner';

export default function useUpdateInsurance(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: InsuranceFormData) =>
      insurancesApi.update(id, insuranceMapper.fromFormToDto(data)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insurancesApiQueryKeys.all(),
      });
      toast.success('Ubezpieczenie zostało zaktualizowane');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas aktualizacji ubezpieczenia.',
      });
    },
  });
}
